import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRewind"><Path d="M11.7685 10.6969L19.5 5V19L11.7685 13.3031M11.5 5L2 12L11.5 19V5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconRewind;
